import React, { useState } from 'react';
import { C, S } from '../../../utils/styles';
import Icon from '../../Icon';
import BulkEmailCompose from './BulkEmailCompose';
import BulkEmailHistory from './BulkEmailHistory';

export default function BulkEmailPanel() {
  const [subTab, setSubTab] = useState('compose');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSent = () => {
    // Bump the history refresh key so the table reloads next time the user opens it.
    setRefreshKey((k) => k + 1);
  };

  return (
    <div data-testid="bulk-email-panel" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ ...S.card, padding: '14px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: 11, color: C.textLight, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              Bulk Email
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginTop: 2 }}>
              Send branded HealthCues emails to your audience
            </div>
            <div style={{ fontSize: 12, color: C.textLight, marginTop: 2 }}>
              Choose Account Managers, Employers, or Employees · target everyone, one client, or specific people · every send is archived.
            </div>
          </div>
          <div style={{ display: 'flex', gap: 4, background: C.bg, borderRadius: 8, padding: 4 }}>
            <SubTab id="compose" active={subTab} onClick={setSubTab} icon="create-outline" label="Compose" />
            <SubTab id="history" active={subTab} onClick={setSubTab} icon="archive-outline" label="History" />
          </div>
        </div>
      </div>

      {subTab === 'compose' && <BulkEmailCompose onSent={handleSent} />}
      {subTab === 'history' && <BulkEmailHistory refreshKey={refreshKey} />}
    </div>
  );
}

function SubTab({ id, active, onClick, icon, label }) {
  const isActive = active === id;
  return (
    <button
      type="button"
      data-testid={`bulk-subtab-${id}`}
      onClick={() => onClick(id)}
      style={{
        padding: '6px 14px',
        borderRadius: 6,
        border: 'none',
        background: isActive ? '#fff' : 'transparent',
        color: isActive ? C.accent : C.textMid,
        fontWeight: isActive ? 700 : 500,
        fontSize: 12,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: "'Inter', sans-serif",
        boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
        transition: 'background 0.15s',
      }}
    >
      <Icon name={icon} style={{ fontSize: 14 }} />
      {label}
    </button>
  );
}
